// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2020-05-15 16:06:25 +0200 (Fri, 15 May 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 110496 $
//  Purpose   : preservation package
// =============================================================================

export const parts = true
export const jobs = true

import * as views from './views'
export {views}
